import React from 'react';

const SnackbarConfig = () => {
  const snackbarRef = React.createRef();

  const closeSnackbar = (key) => {
    if (snackbarRef.current && snackbarRef.current.closeSnackbar) {
      snackbarRef.current.closeSnackbar(key);
    }
  };

  return {
    ref: snackbarRef,
    preventDuplicate: true,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 2000,
    TransitionProps: {
      onEnter: (contentEl) => {
        // prevent screenreaders from reading twice
        contentEl.removeAttribute('aria-describedby');
      },
    },
    action: (key) => (
      <div onClick={() => closeSnackbar(key)} className="snackbar-close">
        &times;
      </div>
    ),
  };
};

export default SnackbarConfig;
